import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../objects/CharacterOxxo";
import { CameraController } from "../../componets3D/CameraController";
import { MouseEvents } from "../../componets3D/MouseEvents";
import { BreakPoint, MapOxxoTopicTwo, PhoneTopicTwo } from "../objects/Topics";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { CubeSelect } from "../objects/CubeSelect";

export class SceneTopicTwo extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.light()
		this.create();
		this.renderAnimations();

		this.interactiveMouse = ""
	}

	create() {
		this.map = new MapOxxoTopicTwo(this.loadingManager);
		this.add(this.map);
		this.add(this.characterSelected)

		this.cubeRed1 = new CubeSelect("red1", 0xFF2e2e)
		this.cubeRed2 = new CubeSelect("red2", 0xFF2e2e)
		this.cubeRed3 = new CubeSelect("red3", 0xFF2e2e)

		this.phoneTopicTwo = new PhoneTopicTwo(this.loadingManager)

		this.breakPoint1 = new BreakPoint(this.loadingManager)
		this.breakPoint2 = new BreakPoint(this.loadingManager)

	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	characterMoveInitScene() {
		this.characterSelected.onAnimateSaludo();
		this.characterSelected.visible = true;
		this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
		this.characterSelected.rotation.set(0, -1.5145, 0);
	}



	sceneActivityOneState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()
		this.mouseEvents.objectsToValue = []
		this.mouseListeners()

		this.characterSelected.position.set(-11.4396, -0.98, 2.676)
		this.characterSelected.rotation.y = -1.5366

	}

	sceneActivityTwoState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()
		this.mouseEvents.objectsToValue = []
		this.mouseListeners()

		this.characterSelected.position.set(-11.4396, -0.98, 2.676)
		this.characterSelected.rotation.y = -1.5366

	}

	resetThree() {
		this.interactiveMouse = ""

		this.map.cafe_1.visible = true
		this.map.cafe_2.visible = true
		this.map.cafe_3.visible = true


		this.map.Detergente_.rotation.set(0, 0, 0)
		this.map.Harina_.rotation.set(0, 0, 0)
		this.map.Harina_3.rotation.set(0, 0, 0)
		this.map.onPositionInit()

		this.map.Gondola001.material.aoMapIntensity = 1

		this.map.clearAnimation()

		this.map.Aguas_10.visible = true
		this.map.Aguas_1001.visible = true
		this.map.Aguas_11.visible = true
		this.map.Aguas_12.visible = true
		this.map.Aguas_13.visible = true
		this.map.Aguas_14.visible = true
		this.map.Aguas_15.visible = true

		this.map.Gondola002.material.aoMapIntensity = 1

		this.cubeRed1.visible = false
		this.cubeRed2.visible = false
		this.cubeRed3.visible = false

		this.phoneTopicTwo.visible = false

		this.breakPoint1.visible = false
		this.breakPoint2.visible = false
		this.breakPoint1.clearAnimation()
		this.breakPoint2.clearAnimation()
	}


	initThree() {

		//* par1
		this.map.cafe_1.visible = false
		this.map.cafe_2.visible = false
		this.map.cafe_3.visible = false

		//* par2
		this.map.Gondola001.material.aoMapIntensity = 0.50

		//* par7
		this.map.Gondola002.material.aoMapIntensity = 0

		this.phoneTopicTwo.visible = false
		this.phoneTopicTwo.position.set(-11.3368, -0.9508, -2.0596)
		this.phoneTopicTwo.rotation.set(-1.5663, 0.0125, 4.1978)
		this.add(this.phoneTopicTwo)

		this.breakPoint1.visible = false
		this.add(this.breakPoint1)
		this.breakPoint2.visible = false
		this.add(this.breakPoint2)

		this.cubeRed1.visible = false
		this.cubeRed1.onAnimationOpacity()
		this.add(this.cubeRed1)

		this.cubeRed2.visible = false
		this.cubeRed2.onAnimationOpacity()
		this.add(this.cubeRed2)

		this.cubeRed3.visible = false
		this.cubeRed3.onAnimationOpacity()
		this.add(this.cubeRed3)
	}

	sceneActivityThreeState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()
		this.mouseEvents.objectsToValue = []
		this.mouseListeners()

		this.characterSelected.position.set(-11.4396, -0.98, 2.676)
		this.characterSelected.rotation.y = -1.5366

		this.initThree()

		ObserverEmitter.on(EVENTS.tema8.topic2.actScene, (step = "") => {
			this.mouseEvents.disposeInteractions()
			this.mouseEvents.objectsToValue = []
			this.mouseListeners()

			this.map.clearAnimation()
			this.breakPoint1.clearAnimation()
			this.breakPoint2.clearAnimation()

			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			switch (step) {
				case "move_gondola_1":

					this.cubeRed1.visible = true
					this.cubeRed1.position.set(-0.6281, -0.9564, 2.3107)
					this.cubeRed1.scale.set(0.55, 0.51, 0.37)
					this.cubeRed1.rotation.set(0, 0, 0)

					this.camera.moveCameraToPoint(new Vector3(0.2799, -0.3115, 4.8865), 1, new Vector3(0.273, -1.165, 2.077), () => {
						this.mouseEvents.objectsToValue = [
							this.cubeRed1
						]
						this.mouseListeners()
						this.interactiveMouse = "move_gondola_1"
					})
					break;
				case "move_floor":
					this.map.Detergente_.position.set(-61.4629, -34.9961, 132.6269)
					this.map.Detergente_.rotation.x = 1.5512

					this.map.Harina_.position.set(-26.1739, 9.1152, 141.4491)
					this.map.Harina_.rotation.x = 0.8894

					this.map.Harina_3.position.y = -8.5293
					this.map.Harina_3.position.z = 137.038
					this.map.Harina_3.rotation.x = 1.5512

					this.map.onAnimateEmissiveMultiIntensity([this.map.Detergente_, this.map.Harina_, this.map.Harina_3])

					this.camera.moveCameraToPoint(new Vector3(-3.3625, -1.5433, -0.4222), 1, new Vector3(-0.455, -1.95, -0.457), () => {
						this.interactiveMouse = "move_floor"
						this.mouseEvents.objectsToValue = [
							this.map.Detergente_,
							this.map.Harina_,
							this.map.Harina_3
						]
						this.mouseListeners()
					})
					break;
				case "move_door_1":
					this.cubeRed1.visible = true
					this.cubeRed1.position.set(-12.2429, -0.1684, 6.8772)
					this.cubeRed1.rotation.set(0, -0.8749, 0)
					this.cubeRed1.scale.set(1.43, 0.63, 0.37)

					this.camera.moveCameraToPoint(new Vector3(-11.0549, 0.0164, 5.8269), 1, new Vector3(-11.859, -0.078, 6.466), () => {
						this.interactiveMouse = "move_door_1"
						this.mouseEvents.objectsToValue = [
							this.cubeRed1
						]
						this.mouseListeners()
					})
					break;
				case "move_door_2":
					this.cubeRed1.visible = false

					this.breakPoint1.visible = true
					this.breakPoint1.position.set(-10.8694, 0.3528, 8.5889)
					this.breakPoint1.rotation.y = 2.4
					this.breakPoint1.VidrioRoto.material.emissive.set(0x5E5E5E);
					this.breakPoint1.VidrioRoto.material.color.set(0xffffff);

					this.breakPoint2.visible = true
					this.breakPoint2.position.set(-12.2189, -1.3014, 6.9695)
					this.breakPoint2.rotation.y = 2.1026

					this.breakPoint1.onAnimateEmissive()
					this.breakPoint2.onAnimateEmissive()

					this.camera.moveCameraToPoint(new Vector3(-9.1478, 0.3187, 5.0373), 1, new Vector3(-9.928, 0.19, 5.7), () => {
						this.interactiveMouse = "move_door_2"
						this.mouseEvents.objectsToValue = [
							this.breakPoint1,
							this.breakPoint2
						]
						this.mouseListeners()
					})
					break;
				case "move_desk_1":
					this.cubeRed1.visible = true
					this.cubeRed1.position.set(-11.1546, 0.0513, -2.8286)
					this.cubeRed1.rotation.set(0, 0, 0)
					this.cubeRed1.scale.set(0.78, 0.66, 0.08)

					this.camera.moveCameraToPoint(new Vector3(-11.5796, 0.1932, -1.7201), 1, new Vector3(-11.233, -0.005, -2.672), () => {
						this.interactiveMouse = "move_desk_1"
						this.mouseEvents.objectsToValue = [
							this.cubeRed1
						]
						this.mouseListeners()

					})
					break;
				case "move_cel_1":
					this.cubeRed1.visible = true

					this.phoneTopicTwo.visible = true
					this.camera.moveCameraToPoint(new Vector3(-11.4918, -0.2731, -2.1071), 1, new Vector3(-11.012, -1.144, -1.825), () => {
						this.cubeRed1.position.set(-11.207, -0.9348, -1.984)
						this.cubeRed1.rotation.set(0, -0.51, 0)
						this.cubeRed1.scale.set(0.3, 0.03, 0.14)

						this.interactiveMouse = "move_cel_1"
						this.mouseEvents.objectsToValue = [
							this.cubeRed1
						]
						this.mouseListeners()

					})
					break;
				case "move_fraudes_1":

					this.map.Aguas_10.visible = false
					this.map.Aguas_1001.visible = false
					this.map.Aguas_11.visible = false
					this.map.Aguas_12.visible = false
					this.map.Aguas_13.visible = false
					this.map.Aguas_14.visible = false
					this.map.Aguas_15.visible = false

					this.cubeRed1.visible = true
					this.cubeRed1.position.set(-4.5877, -0.5381, 6.2718)
					this.cubeRed1.scale.set(1.07, 0.51, 1.84)
					this.cubeRed1.rotation.set(0, 0, 0)

					this.cubeRed2.visible = true
					this.cubeRed2.position.set(-4.5877, -1.4865, 6.2718)
					this.cubeRed2.scale.set(1.07, 0.51, 1.84)

					this.cubeRed3.visible = true
					this.cubeRed3.position.set(-4.5877, -2.4905, 6.2718)
					this.cubeRed3.scale.set(1.07, 0.51, 1.84)

					this.camera.moveCameraToPoint(new Vector3(-7.0965, -0.5922, 6.3879), 1, new Vector3(-6.123, -0.924, 6.375), () => {
						this.interactiveMouse = "move_fraudes_1"
						this.mouseEvents.objectsToValue = [
							this.cubeRed1,
							this.cubeRed2,
							this.cubeRed3,
						]
						this.mouseListeners()
					})
					break;
				case "move_desk_2":
					this.breakPoint1.visible = true
					this.breakPoint1.position.set(-11.1889, 0.0593, -2.7392)
					this.breakPoint1.rotation.set(0, 0, 0)
					this.breakPoint1.scale.set(0.5561, 0.6043)
					this.breakPoint1.VidrioRoto.material.emissive.set(0x1a263d);
					this.breakPoint1.VidrioRoto.material.color.set(0x2199cc);
					this.breakPoint1.onAnimateEmissive()

					this.camera.moveCameraToPoint(new Vector3(-11.5796, 0.1932, -1.7201), 1, new Vector3(-11.233, -0.005, -2.672), () => {
						this.interactiveMouse = "move_desk_2"
						this.mouseEvents.objectsToValue = [
							this.breakPoint1
						]
						this.mouseListeners()
					})
					break;
				case "move_init":
					this.camera.moveCameraToPoint(new Vector3(-12.5814, -0.5836, 2.8129), 1, new Vector3(-11.562, -0.743, 2.816), () => {
						this.characterSelected.visible = true
						ObserverEmitter.emit(EVENTS.tema8.topic2.listenScene, "move_init")
					})
					break;

				default:
					this.resetThree()
					break;
			}
		})



	}

	sceneActivityFourState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()
		this.mouseEvents.objectsToValue = []
	}

	sceneActivityFiveState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()
		this.mouseEvents.objectsToValue = []
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 13.5;
					this.camera.control.maxDistance = 13.5;
					this.camera.control.enablePan = false;

					this.activeAudio()

				})
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5814, -0.5836, 2.8129), 1, new Vector3(-11.562, -0.743, 2.816), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.ennablePan = false;
					this.camera.control.enableZoom = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityOneState();
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-12.5814, -0.5836, 2.8129), 1, new Vector3(-11.562, -0.743, 2.816), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;
					this.camera.control.enableRotate = false;
					this.camera.control.enableZoom = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityTwoState();
				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-12.5814, -0.5836, 2.8129), 1, new Vector3(-11.562, -0.743, 2.816), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityThreeState();
				});
				break;

			case 4:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityFourState();
				});
				break;
			case 5:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityFiveState();
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false

				});
				break;
		}
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;
				console.log(name);
				const selectObjects = {
					move_gondola_1: {
						cubered1: "move_gondola_1"
					},
					move_floor: {
						Detergente_: "move_floor",
						Harina_: "move_floor",
						Harina_3: "move_floor",
					},
					move_door_1: {
						cubered1: "move_door_1"
					},
					move_door_2: {
						VidrioRoto: "move_door_2"
					},
					move_desk_1: {
						cubered1: "move_desk_1"
					},
					move_cel_1: {
						cubered1: "move_cel_1"
					},
					move_fraudes_1: {
						cubered1: "move_fraudes_1",
						cubered2: "move_fraudes_1",
						cubered3: "move_fraudes_1",
					},
					move_desk_2: {
						VidrioRoto: "move_desk_2"
					}
				}
				const nameListen = selectObjects[this.interactiveMouse]
				if (!nameListen) {
					return
				}

				const nameListenMove = nameListen[name]
				if (!nameListenMove) {
					return
				}
				ObserverEmitter.emit(EVENTS.tema8.topic2.listenScene, nameListenMove);
			}
		});
	}

	renderAnimations(delta) {
	}
}
